import * as React from 'react';
import './InputPopup.scss';
import Popup from './Popup'

interface Props {
  title: string;
  text?: string;
  placeholder?: string;
  textera?: boolean;

  type?: 'danger' | 'default' | 'success' | 'warning';
  confirmText?: string;
  confirmColor?: string;

  icon?: string;
  iconColor?: string;
  onConfirm(value: string): void;
  onCancel?(): void;
}

const InputPopup: React.FC<Props> = (props) => {
  const [text, updateText] = React.useState('')

    return (
      <Popup
        warning
        outside
        title={props.title}

        type={props.type}
        icon={props.icon}
        iconColor={props.iconColor}
      >
        <div className='basic-popup-container'>
          <div className='input-popup-text'>
            { props.textera ? (
              <textarea
                value={text}
                onChange={(evt) => updateText(evt.target.value)}
                placeholder={props.placeholder}></textarea>
            ) : (
              <input
                type="text"
                onChange={(evt) => updateText(evt.target.value)}
                placeholder={props.placeholder}
                />
            )}
          </div>
          { props.onConfirm && (
            <div className='basic-popup-button'>
              <button
                type="button"
                className="btn btn-primary"
                onClick={props.onCancel}
                >
                Annuler
              </button>
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => props.onConfirm(text)}
                >
                {props.confirmText || 'Valider'}
              </button>
            </div>
          )}
        </div>
      </Popup>
    );
}

export default InputPopup;
